export function KycInitiationPage() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">KYC Initiation</h1>
      <p className="text-muted-foreground">Initiate KYC verification processes.</p>
    </div>
  );
}
